var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"video"},[_c('youtube',{ref:"player",attrs:{"player-vars":_vm.youtube,"video-id":_vm.youTubeID(_vm.block.content.url)}}),_c('figcaption',{domProps:{"innerHTML":_vm._s(_vm.block.content.caption)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }